import Vue from 'vue'
import App from './App.vue'
import  './store'
// import router from './router/index'
// import './registerServiceWorker'
import "../src/assets/style/index.scss"

Vue.config.productionTip = false;
if (process.env.VUE_APP_RUN_ENV !== "pro") {
  const eruda = require("eruda")
  eruda.init()
}

new Vue({
  // router,
  render: h => h(App)
}).$mount('#app')
